'use client';

import { CalculatorId, type CalculatorConfig } from '../../../lib/calculators/calculator-config';
import { barGraphConfig } from '../bar-graph/bar-graph.config';
import { horizontalBarGraphDescription } from './horizontal-bar-graph.description';

export const horizontalBarGraphConfig: CalculatorConfig<CalculatorId.HorizontalBarGraph> = {
  ...barGraphConfig,
  id: CalculatorId.HorizontalBarGraph,
  initialControlValues: {
    ...barGraphConfig.initialControlValues,
    orientation: 'horizontal'
  }
}; 